<template>
  <div class="app-containers">
    <div class="top_btns">
      <div class="left_box">
        <el-input size="mini" placeholder="请输入存货名称" style="width:34%" v-model="listQuery.name" clearable></el-input>
        <el-button size="mini" type="primary" @click="getList">搜索</el-button>
      </div>
      <div class="right_box">
        <qzf-import-back @success="getList()" from="存货"></qzf-import-back>
      </div>
    </div>
    <el-table stripe size="mini" border :height="contentStyleObj" :data="list">
      <el-table-column align="center" prop="name" label="科目名称" min-width="80">
        <template #default="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="inventoryName" label="存货名称" min-width="80">
        <template #default="scope">
          <span>{{ scope.row.inventoryName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="spec" label="规格型号" min-width="80">
        <template #default="scope">
          <span>{{ scope.row.spec }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="unit" label="计量单位" min-width="80">
        <template #default="scope">
          <span>{{ scope.row.unit }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="count" label="期初数量" min-width="80">
        <template #default="scope">
          <span>{{ scope.row.count }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="amount" label="期初金额" min-width="80">
        <template #default="scope">
          <span>{{ scope.row.amount }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <qzf-pagination v-show="total>0" :total="total" v-model:page="listQuery.page" v-model:limit="listQuery.limit" @pagination="getList" />
    </div>
  </div>
</template>

<script>
import {  importList } from "@/api/inventory"
export default {
  name:'inventoryInit',
  data() {
    return {
      list:[],
      listQuery:{
        page:1,
        limit:20,
        name:''
      },
      total:0
    }
  },
  created(){
    this.getList()
    this.contentStyleObj= this.$getHeight(280)
  },
  methods:{
    getList(){
      importList(this.listQuery).then(res=>{
        if(res.data.msg == "success"){
          this.list = res.data.data.list
          this.total = res.data.data.total
        }else{
          this.list = []
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-containers {
  padding: 10px 20px;
  width: 100%;
  margin: 0 auto 0px auto;
  min-height: calc(100vh - 180px);
  border:1px solid #e6e6e6;
  position: relative;
}
.top_btns {
  margin-bottom: 36px;
   .left_box{
    float: left;
    width: 30%;
  }
  .right_box {
    float: right;
  }
}
</style>